import React, { FC, Fragment } from 'react'
/** @jsx jsx */
import { jsx, css, Global } from '@emotion/core'
import DayPickerInput from 'react-day-picker/DayPickerInput'
import { formatDate } from '@lib/format-date'
import { DatePickerInput } from './DatePickerInput'
// @ts-ignore
import dayPickerStyles from '!!raw-loader!react-day-picker/lib/style.css'
import { customDayPickerStyles } from './common.elements'

type Props = {
  date?: Date
  dateFrom?: Date
  dateTo?: Date
  onChange: (date?: Date) => void
  id?: string
  placeholder?: string
  hasError?: boolean
  disabledDays?: { daysOfWeek: number[] }
}

export const DatePicker: FC<Props> = ({
  date,
  dateFrom,
  dateTo,
  onChange,
  id,
  placeholder,
  hasError,
  disabledDays,
}) => {
  const handleDayChange = (selectedDay: Date) => {
    onChange(selectedDay)
  }

  return (
    <Fragment>
      <Global styles={css(dayPickerStyles)} />
      <Global styles={css(customDayPickerStyles)} />

      <DayPickerInput
        value={date}
        onDayChange={handleDayChange}
        dayPickerProps={{
          selectedDays: [date],
          disabledDays: [
            dateFrom && dateTo && {
              after: dateTo,
              before: dateFrom,
            },
            disabledDays,
          ]
        }}
        component={DatePickerInput}
        inputProps={{
          id,
          placeholder,
          error: hasError,
          onChange: () => {}, // Do nothing on edits, to prevent issues.
          month: new Date(),
          hasError,
        }}
        formatDate={formatDate}
      />
    </Fragment>
  )
}
